/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import { useId } from "react";
import { Button } from "ui/Button";

import type { FC } from "react";

type Props = {
  isCreditCardRegistered: boolean;
  isAgreed: boolean;
};

export const ResaleApplicationSubmissionAction: FC<Props> = ({
  isCreditCardRegistered,
  isAgreed,
}) => {
  const { t } = useI18n();
  const descriptionId = useId();
  const isDisabled = !isAgreed || !isCreditCardRegistered;
  const classes = styles();

  return (
    <div css={classes.root}>
      <Button
        type="submit"
        size="full"
        disabled={isDisabled}
        aria-describedby={isCreditCardRegistered ? undefined : descriptionId}
      >
        {t("event.resale.entry.confirmation.submitEntry")}
      </Button>
      {!isCreditCardRegistered && (
        <p id={descriptionId} css={classes.description}>
          {t("event.resale.entry.confirmation.creditCardRequiredForSubmission")}
        </p>
      )}
    </div>
  );
};

const styles = () => ({
  root: css`
    display: grid;
    gap: 10px;
  `,
  description: css`
    margin: 0;
    color: #f00;
    font-size: 12px;
    line-height: 1.5;
    text-align: center;
  `,
});
